<template>
  <div
    v-if="hide === false"
    style="display: inline-block; width: 10px"
    :class="isActive ? '' : 'inactive'"
    @click="click"
  >
    <v-icon small v-if="isUpward">arrow_upward</v-icon>
    <v-icon small v-else>arrow_downward</v-icon>
  </div>
</template>

<script>
export default {
  props: {
    hide: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    isUpward: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    click() {
      this.$emit('click', () => {})
    },
  },
}
</script>
<style scoped>
div {
  cursor: pointer;
}
.inactive {
  opacity: 0.5;
}
</style>
